// @ts-nocheck
import "./config/sentry"; // Initialize Sentry error tracking (must be first)
import "./config/appInsights"; // Initialize App Insights telemetry
import React from "react";
import ReactDOM from "react-dom/client";
import "@ant-design/v5-patch-for-react-19";
import "antd/dist/reset.css";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { ConfigProvider, theme as antdTheme } from "antd";
import { tokens } from "./theme";
import { Provider } from "react-redux";
import { store } from "./store";
import AuthBootstrap from "./auth/AuthBootstrap";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: `${window.location.origin}/dashboard`,
      audience: audience,
    }}
  >
    <Provider store={store}>
      <AuthBootstrap />
      <ConfigProvider
        theme={{
          algorithm: antdTheme.defaultAlgorithm,
          token: tokens,
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </Auth0Provider>,
);
